/**
 * @file Defines the {@link FOOTER_CONFIG} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Config for what sections to display in footer top & bottom
  * @type {object}
  * @constant
  * @default
  * @property {footer-config} top    - Footer top config
  * @property {footer-config} middle - Footer middle config
  * @property {footer-config} bottom - Footer bottom config
  */
 const FOOTER_CONFIG = {

    top:    [ { id: 'win' } ],
    middle: [ { id: 'name' } ],
    bottom: [

        { 
            id: 'balance',
            siblings: [

                { id: 'text' },
                { id: 'amount' }

            ],
            custom: {
                es: {
                    width: { mobile: '26' }
                },
                jp: {
                    width: { desktop: '15', mobile: '15' }
                }
            }
        },

        { 
            id: 'message',
            custom: {
                es: {
                    width: { mobile: '40' }
                },
                jp: {
                    width: { desktop: '51', mobile: '51' }
                }
            }
        },

        { 
            id: 'clock'
        }

    ]

 }

 export { FOOTER_CONFIG }